
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/admin/calculator",
      function () {
        return require("private-next-pages/admin/calculator/index.tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/admin/calculator"])
      });
    }
  